import React from "react";
import TokenContainer from "../Token/TokenContainer";
import TokenHeader from "../TokenHeader/TokenHeader";
import FanTokenDetails from "./FanTokenDetails";
import TokenTabs from "../Token/TokenTabs";
import FanTokenTabs from "./FanTokenTabs";

const FanToken = () => {
  return (
    <TokenContainer>
      <TokenHeader brand={"/img/company-icon.png"}>
        <FanTokenDetails />
      </TokenHeader>
      {/* <TokenTabs /> */}
      <FanTokenTabs />
    </TokenContainer>
  );
};

export default FanToken;
